// extracted by mini-css-extract-plugin
export default {"user-edit":"UserEdit_user-edit__grIll","user-edit__table":"UserEdit_user-edit__table__xidRj"};